(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  if (!customElements.get('nutra-catalog-filter')) {
    customElements.define('nutra-catalog-filter', class extends HTMLElement {
      connectedCallback() {
        this.chips = this.querySelector('.nutra-catalog__chips');
        this.cards = Array.from(this.querySelectorAll('[data-nutra-category]'));
        this.onClick = (event) => {
          const chip = event.target.closest('[data-nutra-filter]');
          if (!chip || !this.contains(chip)) return;
          event.preventDefault();
          const url = new URL(window.location.href);
          const category = chip.dataset.nutraFilter;
          url.searchParams.delete('nutra_query');
          if (category === 'all') url.searchParams.delete('nutra_category');
          else url.searchParams.set('nutra_category', category);
          window.history.pushState({}, '', url);
          this.applyFilter();
        };
        this.onSort = (event) => {
          if (event.target.id !== 'NutraSortBy') return;
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', event.target.value);
          url.searchParams.delete('page');
          window.location.assign(url);
        };
        this.onPopState = () => this.applyFilter();
        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onSort);
        window.addEventListener('popstate', this.onPopState);
        this.applyFilter();
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('change', this.onSort);
        window.removeEventListener('popstate', this.onPopState);
      }
      applyFilter() {
        const params = new URLSearchParams(window.location.search);
        const requested = params.get('nutra_category') || 'all';
        const query = params.get('nutra_query') || '';
        const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
        const words = normalize(query).split(' ').filter(Boolean);
        const allowed = ['all', 'protein', 'creatine', 'pre-workout', 'fat-burner'];
        const category = allowed.includes(requested) ? requested : 'all';
        this.chips?.querySelectorAll('[data-nutra-filter]').forEach((chip) => {
          const active = chip.dataset.nutraFilter === category;
          chip.classList.toggle('is-active', active);
          if (active) chip.setAttribute('aria-current', 'true');
          else chip.removeAttribute('aria-current');
        });
        this.cards.forEach((card) => {
          const text = normalize(card.dataset.nutraSearchText || '');
          const matchesQuery = words.every((word) => text.includes(word));
          card.hidden = (category !== 'all' && card.dataset.nutraCategory !== category) || !matchesQuery;
        });
        const status = this.querySelector('[data-nutra-catalog-search-status]');
        if (status) {
          const noResults = Boolean(query) && this.cards.every((card) => card.hidden);
          status.hidden = !noResults;
          status.textContent = noResults ? status.dataset.message.replace('[terms]', query) : '';
        }
        this.querySelectorAll('.pagination a').forEach((link) => {
          const url = new URL(link.href);
          if (category === 'all') url.searchParams.delete('nutra_category');
          else url.searchParams.set('nutra_category', category);
          if (query) url.searchParams.set('nutra_query', query);
          else url.searchParams.delete('nutra_query');
          link.href = url;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutramerican-support"] && !Shopify.designMode) return;
  try {
    
  const supportPolicyOpeners = new WeakMap();
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-policy-dialog]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.policyDialog);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      supportPolicyOpeners.set(dialog, trigger);
      dialog.showModal();
      dialog.querySelector('.nutra-support__dialog-body').scrollTop = 0;
      document.body.classList.add('nutra-support-modal-open');
      return;
    }
    const close = event.target.closest('[data-policy-close]');
    if (close) close.closest('dialog').close();
    if (event.target.matches('.nutra-support__dialog')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
  });
  document.addEventListener('close', (event) => {
    if (!event.target.matches('.nutra-support__dialog')) return;
    document.body.classList.remove('nutra-support-modal-open');
    supportPolicyOpeners.get(event.target)?.focus({ preventScroll: true });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  const syncRelatedWheyCards = () => {
    document.querySelectorAll('product-recommendations[data-current-whey-variant]').forEach((section) => {
      const selectedId = new URLSearchParams(window.location.search).get('variant') || section.dataset.currentWheyVariant;
      section.querySelectorAll('[data-related-whey-variant]').forEach((item) => {
        item.hidden = item.dataset.relatedWheyVariant === selectedId;
      });
      if (!section.nutraWheyObserver) {
        section.nutraWheyObserver = new MutationObserver(() => syncRelatedWheyCards());
        section.nutraWheyObserver.observe(section, { childList: true });
      }
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncRelatedWheyCards, { once: true });
  } else {
    syncRelatedWheyCards();
  }
  window.addEventListener('popstate', syncRelatedWheyCards);

  } catch(e) { console.error(e); }
})();
})();
